import { render, staticRenderFns } from "./ItemNfts.vue?vue&type=template&id=9639d7a6&"
import script from "./ItemNfts.vue?vue&type=script&lang=js&"
export * from "./ItemNfts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports